import { SagaIterator } from "redux-saga";
import { call, put, takeLatest } from "redux-saga/effects";

import { callPost } from "../../http_client";

import { requestFailure, requestSuccess, sendRequest } from "./actions";
import { ExtendedReportTypes } from "./types";

export function* handleSendRequest(action: ReturnType<typeof sendRequest>): SagaIterator {
  try {
    const res = yield call(callPost, "/contact/extended_report/", action.payload);
    yield put(requestSuccess());
  } catch (err) {
    yield put(requestFailure(err.message));
  }
}

function* watchExtendedReportSagas(): SagaIterator {
  yield takeLatest(ExtendedReportTypes.SEND_REQUEST, handleSendRequest);
}

export default watchExtendedReportSagas;
